import { useNavigate } from "react-router-dom";
import { AppRoute } from "../../../../interfaces/app-routes";
import MaterialIcon, {
  MtIcon,
} from "../../../../ui-elements/material-icon/material-icon";
import styles from "./menu-item.module.scss";

interface IProps {
  active: boolean;
  collapsed?: boolean;
  to?: AppRoute | string;
  icon?: MtIcon;
  text?: string;
  onClick?: () => void;
  enableRoute?: boolean;
  bgColor?: string;
  bgColorIcon?: string;
}

const MenuItem = (props: IProps) => {
  const { enableRoute = true } = props;

  const navigate = useNavigate();

  return (
    <div
      className={`${styles.menuItemWrapper} ${
        props.active && enableRoute
          ? `${styles[`active`]} ${props.bgColor}`
          : `text-light`
      } p-1`}
      onClick={
        enableRoute
          ? () => {
              props.onClick && props.onClick();
            }
          : undefined
      }
    >
      <div
        onClick={() =>
          enableRoute && props.to ? navigate(props.to) : undefined
        }
        className={`text-decoration-none d-flex align-items-center font-size-16 font-weight-400 cursor-pointer ${
          props.collapsed ? "p-1" : "gap-2"
        } ${!enableRoute && styles.disable} ${!props.collapsed && props.active && enableRoute ? `ms-2` : ``}`}
        style={props.collapsed ? {} : { width: "130px" }}
      >
        <MaterialIcon
          icon={props.icon}
          size={18}
          color={
            props.active && enableRoute
              ? `var(${props.bgColorIcon})`
              : "#69768B"
          }
        />
        {!props.collapsed && <span className="">{props.text}</span>}
      </div>
    </div>
  );
};

export default MenuItem;
